import * as React from 'react';
import Chip from '@mui/material/Chip';
import { Tooltip } from '@mui/material';
import { formatDate, formatBooleanColumns, formatFault, formatVehicleBrand, formatVehicleModel, renderStatus } from '../../utils/utils';

function renderLocked(value) {
  if(value == null) value = false;
  if(value) value = "LOCKED"
  const colors = {
    "LOCKED": 'error',
    false: 'default',
  };
  if(value === "LOCKED")
    return <Chip label={value.toString()} color={colors[value]} size="small" />;
  else return value;
}

const renderType = (typeId, taskTypes) => {
  const type = taskTypes.find(t => t.id == typeId);
  return <Tooltip title={type.name} arrow>
    <Chip label={type?.name} size="small" />
  </Tooltip>
}


export const getTasksColumns = (taskTypes, statuses, vehicleMakes, vehicleModels, vehicleFaults) => [ 
  {
    field: 'id',
    headerName: 'ID',
    description: 'Task ID',
    flex: 0.1,
    minWidth: 50,
  },
  {
    field: 'typeId',
    headerName: 'Type',
    description: 'Type',
    flex: 0.8,
    minWidth: 50,
    renderCell: (params) => renderType(params.row.typeId, taskTypes),
    valueGetter: (value) => {
      const type = taskTypes.find(t => t.id === value);
      return type?.name || '';
    },
  },
  {
    field: 'customerName',
    headerName: 'Customer Name',
    description: 'Customer Name',
    flex: 0.5,
    minWidth: 150,
  },
  {
    field: 'vehicleMakeId',
    headerName: 'Vehicle Brand',
    description: 'Vehicle Brand',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 120,
    valueGetter: value => formatVehicleBrand(value, vehicleMakes)
  },
  {
    field: 'vehicleModelId',
    headerName: 'Vehicle Model',
    description: 'Vehicle Model',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    valueGetter: value => formatVehicleModel(value, vehicleModels)
    //minWidth: 80,
  },
  {
    field: 'vehicleRegistrationNumber',
    headerName: 'Reg #',
    description: 'Vehicle Registration Number',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    //minWidth: 80,
  },
  {
    field: 'isPriority',
    headerName: '⚠️',
    description: 'Is Priority',
    headeralign: 'left',
    align: 'left',
    flex: 0.5,
    maxWidth: 80,
    valueGetter: value => formatBooleanColumns(value),
    renderHeader: (params) => {
      return (
        <Tooltip title="Priority" arrow>
          <span style={{ padding: '0 8px' }}>{params.colDef.headerName}</span>
        </Tooltip>
      )
    }
  },
  {
    field: 'isHomestart',
    headerName: '🏠',
    description: 'Homestart',
    headeralign: 'left',
    align: 'left',
    flex: 0.5,
    maxWidth: 80,
    valueGetter: value => formatBooleanColumns(value),
    renderHeader: (params) => {
      return (
        <Tooltip title="Home Start" arrow>
          <span style={{ padding: '0 8px' }}>{params.colDef.headerName}</span>
        </Tooltip>
      )
    }
  },
  {
    field: 'requiresIntervention',
    headerName: '🧑‍🔧',
    description: 'Requires Intervention',
    headeralign: 'left',
    align: 'left',
    flex: 0.5,
    maxWidth: 80,
    valueGetter: value => formatBooleanColumns(value),
    renderHeader: (params) => {
      return (
        <Tooltip title="Requires Intervention" arrow>
          <span style={{ padding: '0 8px' }}>{params.colDef.headerName}</span>
        </Tooltip>
      )
    }
  },
  {
    field: 'locationDescription',
    headerName: 'Address',
    description: 'Address',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    //minWidth:200,
  },
  {
    field: 'createdOn',
    headerName: 'Created',
    description: 'Created',
    headeralign: 'left',
    align: 'left',
    flex: 1.5,
    //valueGetter: (value) => formatDate(value),
    renderCell: (params) => {
      const formatted = formatDate(params.value, true);
      return (
      <Tooltip title={formatted}>
          {formatted} 
      </Tooltip>
      )
    }
  },
   {
    field: 'statusId',
    headerName: 'Status',
    description: 'Status',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 90,
    renderCell: (params) => renderStatus(params.row.statusId, statuses),
    valueGetter: (value) => {
      const status = statuses.find(s => s.id === value);
      return status?.code || '';
    }
  },
  {
    field: 'faultId',
    headerName: 'Fault',
    description: 'Fault',
    headeralign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 120,
    valueGetter: value => formatFault(value, vehicleFaults)
  },
  {
    field: 'lockedBy',
    headerName: 'Locked',
    description: 'Locked',
    headeralign: 'left',
    align: 'left',
    flex: 0.8,
    maxWidth: 100,
    renderCell: (params) => {
      return renderLocked(params.row?.lockedBy);
    },
    valueGetter:  (value) => {
      return value === true ? 'LOCKED' : ''
    }
  },
  {
    field: 'caseId',
    headerName: 'CASE ID',
    description: 'CASE ID',
    headeralign: 'left',
    align: 'left',
    flex: 0.5,
  },
];

